var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.142578,
    y: 1.13281,
    width: 14.1731,
    height: 13.9319,
    rx: 6.96593,
    transform: "rotate(-0.968347 0.142578 1.13281)",
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38461 11.5L7.38461 4.48437M7.38461 4.48437L5 7M7.38461 4.48437L9.99969 6.93568M7.38461 4.48437L7.29028 4.46094",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.81cbe442d9ed7a2f0e6fcc31dad494dd.svg";
export { ForwardRef as ReactComponent };